const t = "Tabキーを押してポップオーバーに移動", r = {
  triggerHint: t
};
export {
  r as default,
  t as triggerHint
};
